import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {ParameterizationState} from '../types';

export const useParameterizationStore = create<ParameterizationState>()(
  devtools(
    (set) => ({
      // Initial State
      segregationTerms: false,
      segregationTooltip: false,
      maintenance: false,

      // Actions
      setSegregationTerms: (flag) =>
        set(
          {segregationTerms: flag},
          false,
          'parameterization/setSegregationTerms'
        ),

      setSegregationTooltip: (flag) =>
        set(
          {segregationTooltip: flag},
          false,
          'parameterization/setSegregationTooltip'
        ),

      setMaintenance: (flag) =>
        set({maintenance: flag}, false, 'parameterization/setMaintenance')
    }),
    {name: 'ParameterizationStore'}
  )
);

// Selectors
export const selectSegregationTerms = (state: ParameterizationState) =>
  state.segregationTerms;
export const selectSegregationTooltip = (state: ParameterizationState) =>
  state.segregationTooltip;
export const selectMaintenance = (state: ParameterizationState) =>
  state.maintenance;
